"use client";

import { Upload } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button } from "@artha/ui";

type UploadStepProps = {
  selectedFile: File | null;
  isUploading: boolean;
  onChooseFile: () => void;
  onNext: () => void;
  onSignIn: () => void;
};

export function UploadStep({
  selectedFile,
  isUploading,
  onChooseFile,
  onNext,
  onSignIn,
}: UploadStepProps) {
  const t = useTranslations("profile.resumePersonalization");

  return (
    <div className="space-y-4">
      <button
        type="button"
        className="flex min-h-48 w-full flex-col items-center justify-center gap-3 rounded-[14px] border border-dashed border-black bg-white px-6 py-8 text-center"
        onClick={onChooseFile}
      >
        <Upload className="h-7 w-7 text-black" aria-hidden />
        <span className="text-sm font-semibold text-[#344054]">
          {selectedFile ? selectedFile.name : t("upload.selectFile")}
        </span>
        <span className="text-xs text-[#667085]">
          {t("upload.supportedFiles")}
        </span>
      </button>
      <Button
        type="button"
        className="h-12 w-full rounded-[10px] bg-primary font-bold text-primary-foreground"
        disabled={!selectedFile || isUploading}
        onClick={onNext}
      >
        {t("actions.next")}
      </Button>
      <button
        type="button"
        className="w-full text-center text-sm font-semibold underline"
        onClick={onSignIn}
      >
        {t("upload.signIn")}
      </button>
    </div>
  );
}
